<template>
  <b-modal
    class="media-modal"
    v-bind="modalProps"
    :hide-footer="true"
    :hide-header="true"
    modal-class="px-4 py-12"
    body-class="!p-1"
    content-class="!border-0 !rounded-none !w-full"
    :aspect-ratio="aspectRatio"
    @hide="onHide"
  >
    <LazyModalCloseButton
      v-if="showClose"
      align="outside"
      @click="onHide"
    />
    <div class="relative size-full">
      <MediaCarousel
        class="absolute size-full"
        :slides="mediaSlides"
        :autoplay="autoplay"
        lazy-carousel-images
        :initial-slide="defaultCurrentIndex"
        constant-display-navigation
        arrows-align="border"
        arrows-size="sm"
        dots-align="bottom"
      />
    </div>
  </b-modal>
</template>

<script>
import Modal from '@packages/modals/Modal.vue'

export default defineNuxtComponent({
  props: {
    ...Modal.props,
    /**
     * @prop {Array<{
     *   location: string
     *   type: 'cloudinary' | 'youtube'
     *   mediatype: 'image' | 'video'
     * }>}
     */
    mediaList: {
      type: Array,
      default: () => [],
    },

    defaultCurrentIndex: {
      type: Number,
      default: 0,
    },

    showClose: {
      type: Boolean,
      default: false,
    },

    aspectRatio: {
      type: [String, Boolean],
      default: '16/9',
    },

    autoplay: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['onHide'],

  data () {
    return {
      currentIndex: this.defaultCurrentIndex,
    }
  },

  computed: {
    modalProps () {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
      const { mediaList, defaultCurrentIndex, ...modalProps } = this.$props

      return modalProps
    },

    mediaSlides () {
      return (this.mediaList || []).map(media => ({
        ...media,
        url: media.location,
      }))
    },
  },

  watch: {
    defaultCurrentIndex () {
      this.currentIndex = this.defaultCurrentIndex
    },
  },

  methods: {
    onHide () {
      this.currentIndex = this.defaultCurrentIndex
      this.$emit('onHide')
    },
  },
})
</script>

<style lang="scss">
.media-modal {
  min-height: 70px;

  .modal-content {
    max-width: 1600px !important;
  }
}
</style>
